import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/components/admin/auth";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Header";
import { useSeo } from "@/hooks/useSeo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Admin sign in", noindex: true });
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(f.email, f.password); nav("/admin"); } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="admin-login-page">
      <div className="hidden lg:flex bg-emerald-900 hero-grain text-white p-12 flex-col justify-between">
        <Logo light />
        <div>
          <p className="font-display text-4xl font-extrabold leading-tight">Run your deals business<br />from one quiet dashboard.</p>
          <p className="text-emerald-200 mt-4">Imports, scoring, AI drafts, automations and earnings - all in one place.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div className="lg:hidden"><Logo /></div>
          <div>
            <h1 className="text-3xl font-extrabold tracking-tight flex items-center gap-2"><Lock size={22} /> Admin sign in</h1>
            <p className="text-sm text-slate-500 mt-1">Staff only. Shoppers sign in from the website.</p>
          </div>
          <input required type="email" placeholder="Email" autoComplete="username" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
            data-testid="login-email-input" className="w-full h-12 rounded-lg border border-slate-200 px-4 focus:border-emerald-500 outline-none" />
          <input required type="password" placeholder="Password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
            data-testid="login-password-input" className="w-full h-12 rounded-lg border border-slate-200 px-4 focus:border-emerald-500 outline-none" />
          <button disabled={busy} data-testid="login-submit-button" className="w-full h-12 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-bold rounded-lg transition-colors">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-center text-sm"><Link to="/admin/forgot-password" className="text-emerald-700 font-semibold hover:underline" data-testid="forgot-password-link">Forgot password?</Link></p>
        </form>
      </div>
    </div>
  );
}
